import {action, computed, observable} from 'mobx';
import {EventEmitter} from 'events';

export enum MessageFormEvents {
    SEND_MESSAGE = 'SEND_MESSAGE'
}

export class MessageFormController extends EventEmitter {
    @observable private _textMessage: string = '';

    constructor() {
        super();
    }

    @computed
    get textMessage(): string {
        return this._textMessage;
    }

    @computed
    get hasText(): boolean {
        return this._textMessage.trim().length > 0;
    }

    @action
    setTextMessage = (text: string): void => {
        this._textMessage = text;
    };

    @action
    clearTextMessage = (): void => {
        this._textMessage = '';
    };

    @action
    handleSubmit = (): void => {
        if (this.hasText) {
            this.emit(MessageFormEvents.SEND_MESSAGE, this._textMessage);
            this.clearTextMessage();
        }
    };

    @action
    handleKeyPress = (event: {shiftKey: boolean; ctrlKey: boolean; keyCode: number}): void => {
        if (!(event.shiftKey || event.ctrlKey) && event.keyCode === 13) {
            // Enter key without shift/ctrl - send message
            this.handleSubmit();
        } else if ((event.shiftKey || event.ctrlKey) && event.keyCode === 13) {
            // Shift/Ctrl + Enter - add new line (handled by textarea naturally)
            this._textMessage += '\n';
        }
    };
}
